import { render, staticRenderFns } from "./kpiTemplateEdit.vue?vue&type=template&id=5d10d05b&scoped=true"
import script from "./kpiTemplateEdit.vue?vue&type=script&lang=js"
export * from "./kpiTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10d05b",
  null
  
)

export default component.exports